const LoadingSoundButtonController = require('LoadingSoundButtonController');
const PSState = require('PSState');

cc.Class({
    extends: LoadingSoundButtonController,

    properties: {
        skeleton: sp.Skeleton,
        enabledAnimations: [cc.String],
        enabledLastLoop: false,
        disabledAnimations: [cc.String],
        disabledLastLoop: false,
    },

    toggleSound() {
        const soundEnabled = !this._soundEnabled;

        if (!soundEnabled) {
            this.audioMap.playOneShot('introAudioDisable');
        }
        PSState.set({ soundEnabled });
        if (soundEnabled) {
            this.audioMap.playOneShot('introAudioEnable');
        }
    },

    _updateSoundButton () {
        if (this._soundEnabled) {
            if (!this.enabledAnimations.includes(this.skeleton.animation)) {
                this._setAnimations(this.enabledAnimations, this.enabledLastLoop);
            }
        } else {
            if (!this.disabledAnimations.includes(this.skeleton.animation)) {
                this._setAnimations(this.disabledAnimations, this.disabledLastLoop);
            }
        }
    },

    _setAnimations (animations, lastLoop) {
        const l = animations.length;
        animations.forEach((anim, i) => {
            if (i === 0) {
                this.skeleton.setAnimation(0, anim, i === l && lastLoop);
            } else {
                this.skeleton.addAnimation(0, anim, i === l && lastLoop);
            }
        });
    },

    _stateUpdate (data) {
        if (this._soundEnabled === data.soundEnabled) {
            return;
        }
        this._soundEnabled = data.soundEnabled;
        this._updateSoundButton();


    }
});
